import { render, staticRenderFns } from "./TemperaturePulseDevice.vue?vue&type=template&id=1ff8ae32&scoped=true"
import script from "./TemperaturePulseDevice.vue?vue&type=script&lang=js"
export * from "./TemperaturePulseDevice.vue?vue&type=script&lang=js"
import style0 from "./TemperaturePulseDevice.vue?vue&type=style&index=0&id=1ff8ae32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff8ae32",
  null
  
)

export default component.exports